export var DRAGGING_ITEM_NAME = 'DRAGGING_FEET';
